/** @jsx jsx */
import { jsx } from '@emotion/core';
import Enquiry from '../Enquiry';
import { SafePureComponent } from '../../../utils/SafePureComponent';

const analyticsFormName = 'get a quote';
const headlineDictionary = 'GetAQuoteHeadline';
const submitDictionary = 'RequestYourQuoteCTA';

export class GetAQuote extends SafePureComponent {
  safeRender() {
    const { props } = this;

    return (
      <Enquiry
        {...props}
        formName={analyticsFormName}
        headlineDictionary={headlineDictionary}
        submitDictionary={submitDictionary}
      />
    );
  }
}

GetAQuote.displayName = 'GetAQuote';

export default GetAQuote;
